import React, { useState } from 'react';
import { useQuery, useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { Card, CardBody, Table } from 'reactstrap';
import { applicationServicesHeaders } from '../constants';
import {
  fetchExecutionServiceDetails,
  executeServiceProcess,
} from '../../../store/apis/adminService';
import SyncIcon from '../../../assets/icons/sync.svg';

import './ApplicationServices.scss';

function ApplicationServices() {
  document.title = 'Admin - Application Services | Daikin - Envision';
  const [isLoadingIndex, setIsLoadingIndex] = useState(null);

  const { data: executionServiceDetails } = useQuery({
    queryKey: ['executionServiceDetails'],
    queryFn: fetchExecutionServiceDetails,
    keepPreviousData: true,
  });
  const { mutate: executeServiceProcessMutation, isPending } = useMutation({
    mutationFn: executeServiceProcess,
    onSuccess: (dataResponse, params) => {
      const findService = executionServiceDetails?.find(
        item => Number(item?.ProcessId) === Number(params?.processId),
      );
      toast.success(`${findService?.ProcessName} Executed Successfully.`, {
        className: 'toast-success',
      });
      setIsLoadingIndex(null);
    },
    onError: () => {
      toast.error('Failed to execute service process.', {
        className: 'toast-error',
      });
      setIsLoadingIndex(null);
    },
  });

  const handleExecuteServiceProcess = serviceData => {
    const payload = {
      processId: serviceData?.ProcessId?.toString(),
      procedureType: serviceData?.ProcType,
    };
    setIsLoadingIndex(serviceData?.ProcessId);
    executeServiceProcessMutation(payload);
  };

  const renderTableBody = () =>
    executionServiceDetails?.map(item => (
      <tr key={item?.processName}>
        <td className="py-2">{item?.ProcessName}</td>
        <td className="py-2">{item?.Description}</td>
        <td className="py-2">
          <div className="d-flex justify-content-center">
            <button
              type="button"
              className="custom-btn sync-btn"
              onClick={() => handleExecuteServiceProcess(item)}
              disabled={isPending && isLoadingIndex === item?.ProcessId}
            >
              <img src={SyncIcon} alt="Sync" className="sync-icon" />
            </button>
          </div>
        </td>
      </tr>
    ));
  return (
    <div className="page-content as-page">
      <Card className="as-card">
        <div className="px-3 pt-3 pb-3">
          <span className="fs-5" style={{ color: '#000', fontWeight: '600' }}>
            Application Services
          </span>
        </div>
        <CardBody className="p-0">
          <div className="table-responsive as-table-container">
            <Table
              hover
              className="custom-table align-middle text-nowrap as-table"
            >
              <thead>
                <tr>
                  <th className="py-2 fw-semibold">Execute</th>
                  {applicationServicesHeaders?.map(header => (
                    <th
                      className="py-2 fw-semibold"
                      style={{
                        width: header === 'Process Name' ? '60%' : '10%',
                      }}
                    >
                      {header}
                    </th>
                  ))}
                  <th className="py-2 fw-semibold text-center">Action</th>
                </tr>
              </thead>
              <tbody>{renderTableBody()}</tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
    </div>
  );
}

export default ApplicationServices;
